// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!../../../node_modules/react-perfect-scrollbar/dist/css/styles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullscreen .react-images__blanket {
  z-index: 1200;
}

.apexcharts-legend-series .apexcharts-legend-marker {
  margin-right: 8px;
}

.scrollbar-container .ps__rail-y:hover > .ps__thumb-y, .scrollbar-container .ps__rail-y:focus > .ps__thumb-y, .scrollbar-container .ps__rail-y.ps--clicking .ps__thumb-y {
  background-color: #697586;
  width: 5px;
}
.scrollbar-container .ps__thumb-y {
  background-color: #697586;
  border-radius: 6px;
  width: 5px;
  right: 0;
}

.scrollbar-container.ps.ps--active-y > .ps__rail-y,
.scrollbar-container > .ps.ps--active-y > .ps__rail-y {
  width: 5px;
  background-color: transparent !important;
  z-index: 999;
}
.scrollbar-container.ps.ps--active-y > .ps__rail-y:hover, .scrollbar-container.ps.ps--active-y > .ps__rail-y.ps--clicking,
.scrollbar-container > .ps.ps--active-y > .ps__rail-y:hover,
.scrollbar-container > .ps.ps--active-y > .ps__rail-y.ps--clicking {
  width: 5px;
  background-color: transparent;
}
.scrollbar-container.ps.ps--scrolling-y > .ps__rail-y, .scrollbar-container.ps.ps--scrolling-x > .ps__rail-x,
.scrollbar-container > .ps.ps--scrolling-y > .ps__rail-y,
.scrollbar-container > .ps.ps--scrolling-x > .ps__rail-x {
  opacity: 0.4;
  background-color: transparent;
}

@keyframes wings {
  50% {
    transform: translateY(-40px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes blink {
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes bounce {
  0%, 20%, 53%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translateZ(0);
  }
  40%, 43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -5px, 0);
  }
  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -7px, 0);
  }
  80% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translateZ(0);
  }
  90% {
    transform: translate3d(0, -2px, 0);
  }
}
@keyframes slideY {
  0%, 50%, 100% {
    transform: translateY(0px);
  }
  25% {
    transform: translateY(-10px);
  }
  75% {
    transform: translateY(10px);
  }
}
@keyframes slideX {
  0%, 50%, 100% {
    transform: translateX(0px);
  }
  25% {
    transform: translateX(-10px);
  }
  75% {
    transform: translateX(10px);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/style.scss","webpack://./src/assets/scss/_themes-vars.module.scss"],"names":[],"mappings":"AAOA;EACE,aAAA;AA+CF;;AA1CA;EACE,iBAAA;AA6CF;;AAtCI;EAGE,yBCmBI;EDlBJ,UAAA;AAuCN;AApCE;EACE,yBCcM;EDbN,kBAAA;EACA,UAAA;EACA,QAAA;AAsCJ;;AAhCE;;EACE,UAAA;EACA,wCAAA;EACA,YAAA;AAoCJ;AAnCI;;;EAEE,UAAA;EACA,6BAAA;AAsCN;AAnCE;;;EAEE,YAAA;EACA,6BAAA;AAsCJ;;AAhCA;EACE;IACE,4BAAA;EAmCF;EAjCA;IACE,0BAAA;EAmCF;AACF;AAhCA;EACE;IACE,UAAA;EAkCF;EAhCA;IACE,UAAA;EAkCF;AACF;AA/BA;EACE;IAIE,8DAAA;IACA,wBAAA;EA8BF;EA5BA;IAEE,iEAAA;IACA,kCAAA;EA6BF;EA3BA;IACE,iEAAA;IACA,kCAAA;EA6BF;EA3BA;IACE,+DAAA;IACA,wBAAA;EA6BF;EA3BA;IACE,kCAAA;EA6BF;AACF;AA1BA;EACE;IAGE,0BAAA;EA0BF;EAxBA;IACE,4BAAA;EA0BF;EAxBA;IACE,2BAAA;EA0BF;AACF;AAvBA;EACE;IAGE,0BAAA;EAuBF;EArBA;IACE,4BAAA;EAuBF;EArBA;IACE,2BAAA;EAuBF;AACF","sourcesContent":["// color variants\n@import 'themes-vars.module.scss';\n\n// third-party\n@import '~react-perfect-scrollbar/dist/css/styles.css';\n\n// ==============================|| LIGHT BOX ||============================== //\n.fullscreen .react-images__blanket {\n  z-index: 1200;\n}\n\n// ==============================|| APEXCHART ||============================== //\n\n.apexcharts-legend-series .apexcharts-legend-marker {\n  margin-right: 8px;\n}\n\n// ==============================|| PERFECT SCROLLBAR ||============================== //\n\n.scrollbar-container {\n  .ps__rail-y {\n    &:hover > .ps__thumb-y,\n    &:focus > .ps__thumb-y,\n    &.ps--clicking .ps__thumb-y {\n      background-color: $grey500;\n      width: 5px;\n    }\n  }\n  .ps__thumb-y {\n    background-color: $grey500;\n    border-radius: 6px;\n    width: 5px;\n    right: 0;\n  }\n}\n\n.scrollbar-container.ps,\n.scrollbar-container > .ps {\n  &.ps--active-y > .ps__rail-y {\n    width: 5px;\n    background-color: transparent !important;\n    z-index: 999;\n    &:hover,\n    &.ps--clicking {\n      width: 5px;\n      background-color: transparent;\n    }\n  }\n  &.ps--scrolling-y > .ps__rail-y,\n  &.ps--scrolling-x > .ps__rail-x {\n    opacity: 0.4;\n    background-color: transparent;\n  }\n}\n\n// ==============================|| ANIMATION KEYFRAMES ||============================== //\n\n@keyframes wings {\n  50% {\n    transform: translateY(-40px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n@keyframes blink {\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes bounce {\n  0%,\n  20%,\n  53%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translateZ(0);\n  }\n  40%,\n  43% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translate3d(0, -5px, 0);\n  }\n  70% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translate3d(0, -7px, 0);\n  }\n  80% {\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translateZ(0);\n  }\n  90% {\n    transform: translate3d(0, -2px, 0);\n  }\n}\n\n@keyframes slideY {\n  0%,\n  50%,\n  100% {\n    transform: translateY(0px);\n  }\n  25% {\n    transform: translateY(-10px);\n  }\n  75% {\n    transform: translateY(10px);\n  }\n}\n\n@keyframes slideX {\n  0%,\n  50%,\n  100% {\n    transform: translateX(0px);\n  }\n  25% {\n    transform: translateX(-10px);\n  }\n  75% {\n    transform: translateX(10px);\n  }\n}\n","// paper & background\n$paper: #ffffff;\n\n// primary\n$primaryLight: #eef2f6;\n$primaryMain: #2196f3;\n$primaryDark: #1e88e5;\n$primary200: #90caf9;\n$primary800: #1565c0;\n\n// secondary\n$secondaryLight: #ede7f6;\n$secondaryMain: #673ab7;\n$secondaryDark: #5e35b1;\n$secondary200: #b39ddb;\n$secondary800: #4527a0;\n\n// success Colors\n$successLight: #b9f6ca;\n$success200: #69f0ae;\n$successMain: #00e676;\n$successDark: #00c853;\n\n// error\n$errorLight: #ef9a9a;\n$errorMain: #f44336;\n$errorDark: #c62828;\n\n// orange\n$orangeLight: #fbe9e7;\n$orangeMain: #ffab91;\n$orangeDark: #d84315;\n\n// warning\n$warningLight: #fff8e1;\n$warningMain: #ffe57f;\n$warningDark: #ffc107;\n\n// grey\n$grey50: #f8fafc;\n$grey100: #eef2f6;\n$grey200: #e3e8ef;\n$grey300: #cdd5df;\n$grey500: #697586;\n$grey600: #4b5565;\n$grey700: #364152;\n$grey900: #121926;\n\n// ==============================|| DARK THEME VARIANTS ||============================== //\n\n// paper & background\n$darkBackground: #1a223f; // level 3\n$darkPaper: #111936; // level 4\n\n// dark 800 & 900\n$darkLevel1: #29314f; // level 1\n$darkLevel2: #212946; // level 2\n\n// primary dark\n$darkPrimaryLight: #eef2f6;\n$darkPrimaryMain: #2196f3;\n$darkPrimaryDark: #1e88e5;\n$darkPrimary200: #90caf9;\n$darkPrimary800: #1565c0;\n\n// secondary dark\n$darkSecondaryLight: #d1c4e9;\n$darkSecondaryMain: #7c4dff;\n$darkSecondaryDark: #651fff;\n$darkSecondary200: #b39ddb;\n$darkSecondary800: #6200ea;\n\n// text variants\n$darkTextTitle: #d7dcec;\n$darkTextPrimary: #bdc8f0;\n$darkTextSecondary: #8492c4;\n\n// ==============================|| JAVASCRIPT ||============================== //\n\n:export {\n  // paper & background\n  paper: $paper;\n\n  // primary\n  primaryLight: $primaryLight;\n  primary200: $primary200;\n  primaryMain: $primaryMain;\n  primaryDark: $primaryDark;\n  primary800: $primary800;\n\n  // secondary\n  secondaryLight: $secondaryLight;\n  secondary200: $secondary200;\n  secondaryMain: $secondaryMain;\n  secondaryDark: $secondaryDark;\n  secondary800: $secondary800;\n\n  // success\n  successLight: $successLight;\n  success200: $success200;\n  successMain: $successMain;\n  successDark: $successDark;\n\n  // error\n  errorLight: $errorLight;\n  errorMain: $errorMain;\n  errorDark: $errorDark;\n\n  // orange\n  orangeLight: $orangeLight;\n  orangeMain: $orangeMain;\n  orangeDark: $orangeDark;\n\n  // warning\n  warningLight: $warningLight;\n  warningMain: $warningMain;\n  warningDark: $warningDark;\n\n  // grey\n  grey50: $grey50;\n  grey100: $grey100;\n  grey200: $grey200;\n  grey300: $grey300;\n  grey500: $grey500;\n  grey600: $grey600;\n  grey700: $grey700;\n  grey900: $grey900;\n\n  // ==============================|| DARK THEME VARIANTS ||============================== //\n\n  // paper & background\n  darkPaper: $darkPaper;\n  darkBackground: $darkBackground;\n\n  // dark 800 & 900\n  darkLevel1: $darkLevel1;\n  darkLevel2: $darkLevel2;\n\n  // text variants\n  darkTextTitle: $darkTextTitle;\n  darkTextPrimary: $darkTextPrimary;\n  darkTextSecondary: $darkTextSecondary;\n\n  // primary dark\n  darkPrimaryLight: $darkPrimaryLight;\n  darkPrimaryMain: $darkPrimaryMain;\n  darkPrimaryDark: $darkPrimaryDark;\n  darkPrimary200: $darkPrimary200;\n  darkPrimary800: $darkPrimary800;\n\n  // secondary dark\n  darkSecondaryLight: $darkSecondaryLight;\n  darkSecondaryMain: $darkSecondaryMain;\n  darkSecondaryDark: $darkSecondaryDark;\n  darkSecondary200: $darkSecondary200;\n  darkSecondary800: $darkSecondary800;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `#ffffff`,
	"primaryLight": `#eef2f6`,
	"primary200": `#90caf9`,
	"primaryMain": `#2196f3`,
	"primaryDark": `#1e88e5`,
	"primary800": `#1565c0`,
	"secondaryLight": `#ede7f6`,
	"secondary200": `#b39ddb`,
	"secondaryMain": `#673ab7`,
	"secondaryDark": `#5e35b1`,
	"secondary800": `#4527a0`,
	"successLight": `#b9f6ca`,
	"success200": `#69f0ae`,
	"successMain": `#00e676`,
	"successDark": `#00c853`,
	"errorLight": `#ef9a9a`,
	"errorMain": `#f44336`,
	"errorDark": `#c62828`,
	"orangeLight": `#fbe9e7`,
	"orangeMain": `#ffab91`,
	"orangeDark": `#d84315`,
	"warningLight": `#fff8e1`,
	"warningMain": `#ffe57f`,
	"warningDark": `#ffc107`,
	"grey50": `#f8fafc`,
	"grey100": `#eef2f6`,
	"grey200": `#e3e8ef`,
	"grey300": `#cdd5df`,
	"grey500": `#697586`,
	"grey600": `#4b5565`,
	"grey700": `#364152`,
	"grey900": `#121926`,
	"darkPaper": `#111936`,
	"darkBackground": `#1a223f`,
	"darkLevel1": `#29314f`,
	"darkLevel2": `#212946`,
	"darkTextTitle": `#d7dcec`,
	"darkTextPrimary": `#bdc8f0`,
	"darkTextSecondary": `#8492c4`,
	"darkPrimaryLight": `#eef2f6`,
	"darkPrimaryMain": `#2196f3`,
	"darkPrimaryDark": `#1e88e5`,
	"darkPrimary200": `#90caf9`,
	"darkPrimary800": `#1565c0`,
	"darkSecondaryLight": `#d1c4e9`,
	"darkSecondaryMain": `#7c4dff`,
	"darkSecondaryDark": `#651fff`,
	"darkSecondary200": `#b39ddb`,
	"darkSecondary800": `#6200ea`
};
export default ___CSS_LOADER_EXPORT___;
